import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePartnerStatus } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useUpdatePartnerStatusMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ partnerProfileId, status, plans }) => {
      const result = await updatePartnerStatus({ partnerProfileId, status, plans });
      if (!result.success) {
        throw new Error(result.message || 'Failed to update partner status');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
